import { useState, useEffect } from 'react';

import {
    Box,
    IconButton,
    Menu,
    TextField,
    MenuItem,
    Chip
} from '@material-ui/core';

import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { API } from 'aws-amplify';

import { handleOnBlurSystemPromptModelSetting, handleChangeModel } from '@/component/productManagement/handler/VersionListHandler';
import OverFlowTooltipWithCustomCss from '@/component/common/OverFlowTooltipWithCustomCss';
import { openPromptTicketPanel } from '@/component/chatAI/handler/ChatAIHandler';
import { userAtom } from '@/state/atom/userAtom';
import { useRecoilValue } from 'recoil';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { checkModelUnsupport } from '@/component/system/handler/OrganizationProfileHandler';

import PropTypes from 'prop-types';
import ProductManagementConstant from '@/common/constant/ProductManagementConstant';
import trI18n from '@/common/utils/trI18n';
import tr from '@/common/utils/tr';
import useTranslationSubscription from '@/hooks/useTranslation';

const AddModelSettingRow = ({
    currentAddList,
    modelSettingList,
    currentIndex,

    usingChatAI,
    usingAIAuto,
    setIsLoading,
    setIsEdited,
    setIsOpenModalReloadPage,
    addNewPanel,
    chatGPTModelList,
    onDeleteModelSetting,
    modelSettingDetail,
    setModelSettingAddList,
    setModelSettingList,
    setIsOpenAccessDeniedPopup
}) => {
    useTranslationSubscription();

    const userDetail = useRecoilValue(userAtom);
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const [modelSetting, setModelSetting] = useState(modelSettingDetail);

    const [systemPrompt, setSystemPrompt] = useState(modelSettingDetail?.systemPrompt);
    const [interatorSystemPrompt, setInteratorSystemPrompt] = useState(
        modelSettingDetail?.interatorSystemPrompt
    );

    const [inputSystemPrompt, setInputSystemPrompt] = useState(
        modelSettingDetail?.systemPrompt?.linkPrompt
    );
    const [inputInteratorSystemPrompt, setInputInteratorSystemPrompt] = useState(
        modelSettingDetail?.interatorSystemPrompt?.linkPrompt
    );

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        setInputSystemPrompt(modelSettingDetail?.systemPrompt?.linkPrompt);
        setInputInteratorSystemPrompt(modelSettingDetail?.interatorSystemPrompt?.linkPrompt);
        setSystemPrompt(modelSettingDetail?.systemPrompt);
        setInteratorSystemPrompt(modelSettingDetail?.interatorSystemPrompt);
    }, [modelSettingDetail]);

    const handleDisableSystemPromptInput = () => {
        return !usingChatAI || !usingAIAuto;
    };

    const renderFieldSystemPrompt = (
        systemPromptData,
        setSystemPromptData,
        inputSystemPromptData,
        setInputSystemPromptData,
        fieldKey
    ) => {
        return (
            <div className="prompt-basic-chip-ai-auto org-profile-system-prompt-input prompt-basic-chip-ai-auto-column">
                {!systemPromptData?.value ||
                (systemPromptData?.value && systemPromptData?.error) ? (
                    <>
                        <TextField
                            className="form-control-input form-control-wrapInput form-control-hg32 input-basic-chip"
                            variant="outlined"
                            spellCheck={false}
                            autoComplete="seriously-please-don't-autocomplete"
                            type="text"
                            onBlur={e =>
                                handleSystemPromptBlur(e, {
                                    API,
                                    fieldKey,
                                    setIsLoading,
                                    systemPromptData,
                                    setIsEdited,
                                    setModelSettingAddList,
                                    currentIndex
                                })
                            }
                            helperText={''}
                            error={!Utils.isEmptyString(systemPromptData?.error)}
                            disabled={handleDisableSystemPromptInput()}
                            value={inputSystemPromptData}
                            onChange={e => {
                                setInputSystemPromptData(e.target.value);
                            }}
                        />
                        {!Utils.isEmptyString(systemPromptData?.error) && (
                            <div>
                                <span className="text-warning-chat-ai text-warning-model">
                                    {trI18n(systemPromptData?.error)}
                                </span>
                            </div>
                        )}
                    </>
                ) : (
                    <Chip
                        label={
                            <OverFlowTooltipWithCustomCss
                                value={systemPromptData?.value}
                                placement={'top'}
                            />
                        }
                        onClick={async () => {
                            if (Utils.isEmptyString(systemPromptData?.value)) return;
                            const idTicket = await Utils.getTicketIdByShareLink(
                                systemPromptData?.linkPrompt
                            );
                            openPromptTicketPanel(
                                setIsLoading,
                                userDetail,
                                idTicket,
                                projectInuseDetail,
                                setIsOpenModalReloadPage,
                                addNewPanel,
                                setIsOpenAccessDeniedPopup
                            );
                        }}
                        onDelete={() => {
                            if (handleDisableSystemPromptInput()) return true;
                            setSystemPromptData(prev => ({
                                ...prev,
                                error: '',
                                value: '',
                                linkPrompt: ''
                            }));
                            setIsEdited(true);
                            setInputSystemPromptData('');
                        }}
                        disableRipple={handleDisableSystemPromptInput()}
                        deleteIcon={
                            <img
                                className={`basic-chip-delete-icon ${
                                    handleDisableSystemPromptInput()
                                        ? 'basic-chip-delete-icon-disable'
                                        : ''
                                }`}
                                src="/assets/image/delete-icon-rounded.svg"
                                alt="delete"
                            />
                        }
                        className={`basic-chip chip-ai-auto top-4px ${
                            handleDisableSystemPromptInput() ? 'basic-chip-disable' : ''
                        }`}
                    />
                )}
            </div>
        );
    };

    // render name model setting
    const renderModelList = (model, index) => {
        const modelErrorMessage = [
            {
                condition: checkModelUnsupport(modelSetting?.model, chatGPTModelList),
                message: trI18n('MSG-AI-UNSUPPORTED-MODEL').replace(
                    Constant.MODEL_NAME_PLACEHOLDER,
                    modelSetting?.model
                )
            },
            {
                condition: modelSettingDetail.isModelBlank,
                message: trI18n('MSG-CM-REQUIRED-INPUT')
            },
            {
                condition: modelSettingDetail.hasDuplicate,
                message: trI18n('MSG_AI_MODEL_DUPLICATE')
            }
        ].find(item => item.condition)?.message;
        return (
            <>
                <div className="model-setting-item">
                    <label className="setting-label">
                        {trI18n('ORG-INFOR-LABEL-CHATGPT-MODEL')}
                    </label>
                    <div>
                        {/* hamburger icon */}
                        <IconButton
                            className="close more-model-setting"
                            aria-label="more"
                            id="long-button-hamburger"
                            aria-controls={open ?? 'long-menu'}
                            aria-expanded={open ?? 'true'}
                            aria-haspopup="true"
                            onClick={handleClick}
                            disabled={handleDisableSystemPromptInput()}
                        >
                            <img src="/assets/image/icon-hamburger.svg" alt="Icon hamburger" />
                        </IconButton>
                        <Menu
                            id="long-menu-hamburger"
                            className="view-mode-group-btn"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            getContentAnchorEl={null}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right'
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right'
                            }}
                            MenuListProps={{
                                className: 'view-mode-group-btn-hamburger'
                            }}
                            PaperProps={{
                                style: {
                                    minWidth: '160px',
                                    minHeight: '40px'
                                }
                            }}
                        >
                            <div className="hamburger-list">
                                {/* Delete Model Setting */}
                                <Box
                                    className="hamburger-item"
                                    onClick={() => {
                                        // comment for now
                                        onDeleteModelSetting();
                                        handleClose();
                                    }}
                                >
                                    <IconButton className="itemNav">
                                        <img src="/assets/image/icon-tabs-delete.svg" alt="" />
                                    </IconButton>
                                    {trI18n('HAMBURGER-DELETE')}
                                </Box>
                            </div>
                        </Menu>
                    </div>
                </div>
                <TextField
                    className="form-control-input form-control-wrapInput form-control-hg32 width-80 chatGPT-model"
                    select
                    disabled={handleDisableSystemPromptInput()}
                    variant="outlined"
                    name="selectedChatGPTModel"
                    value={`${modelSetting?.model || ''}`}
                    defaultValue={`${modelSetting?.model || ''}`}
                    SelectProps={{
                        value: `${modelSetting?.model || ''}`,
                        MenuProps: {
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left'
                            },
                            getContentAnchorEl: null,
                            className: 'selectDrop'
                        }
                    }}
                    error={modelErrorMessage}
                    onChange={e => {
                        let dataChange = {
                            modelSetting, 
                            setModelSetting, 
                            currentAddList, 
                            currentIndex, 
                            setModelSettingAddList,
                            modelSettingList,
                            setModelSettingList,
                            chatGPTModelList,
                            setIsEdited
                        }
                        handleChangeModel(e, dataChange)
                    }}
                >
                    {chatGPTModelList.map(chatGPT => {
                        return (
                            <MenuItem
                                key={`chatGPT-${chatGPT.id}`}
                                value={chatGPT.id}
                                className={
                                    chatGPT?.status === Constant.CHAT_GPT_MODEL_STATUS.UNSUPPORT &&
                                    'd-hidden'
                                }
                            >
                                <OverFlowTooltipWithTabsMui
                                    className={`className-${chatGPT.id}`}
                                    value={chatGPT.id}
                                >
                                    {chatGPT.id}
                                </OverFlowTooltipWithTabsMui>
                            </MenuItem>
                        );
                    })}
                </TextField>
                {modelErrorMessage && (
                    <div>
                        <span className="text-warning-chat-ai text-warning-model">
                            {modelErrorMessage}
                        </span>
                    </div>
                )}
            </>
        );
    };

    const updateItemPrompt = (item, fieldKey, newValue, newLinkPrompt) => {
        if (item.id !== currentIndex) return item;
        return {
            ...item,
            [fieldKey]: {
                ...item[fieldKey],
                value: newValue,
                linkPrompt: newLinkPrompt
            }
        };
    };

    const handleSystemPromptBlur = async (e, data) => {
        const { fieldKey } = data;

        setModelSettingAddList(prevList =>
            prevList.map(item => updateItemPrompt(item, fieldKey, '', e.target.value))
        );

        await handleOnBlurSystemPromptModelSetting({
            e,
            ...data
        });
    };

    const isHideBorder =
        Utils.isEmptyArray(modelSettingList) &&
        currentIndex === currentAddList[currentAddList.length - 1].id;

    return (
        <div
            key={modelSetting.id}
            className={`model-setting-item-common ${isHideBorder ? 'model-setting-last-item' : ''}`}
        >
            {/* CHATGPT_MODEL */}
            {renderModelList()}

            {/* SYSTEM PROMPT */}
            <div className="model-setting-item model-setting-item-prompt">
                <label className="setting-label">
                    {tr(ProductManagementConstant.TEXTBOX_SETTING_SYSTEM_PROMPT)}
                </label>
            </div>
            {renderFieldSystemPrompt(
                systemPrompt,
                setSystemPrompt,
                inputSystemPrompt,
                setInputSystemPrompt,
                Constant.MODEL_PROMPT_TYPE.SYSTEM_PROMPT
            )}
        </div>
    );
};
export default AddModelSettingRow;

AddModelSettingRow.propTypes = {
    currentAddList: PropTypes.any,
    modelSettingList: PropTypes.any,
    currentIndex: PropTypes.any,
    usingChatAI: PropTypes.any,
    usingAIAuto: PropTypes.any,
    setIsLoading: PropTypes.any,
    setIsEdited: PropTypes.any,
    setIsOpenModalReloadPage: PropTypes.any,
    addNewPanel: PropTypes.any,
    chatGPTModelList: PropTypes.any,
    onDeleteModelSetting: PropTypes.any,
    modelSettingDetail: PropTypes.any,
    setModelSettingAddList: PropTypes.any,
    setModelSettingList: PropTypes.any,
    setIsOpenAccessDeniedPopup: PropTypes.any,
};
